import { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import "./AddVendorAddress.css";

function AddVendorAddress({ setShowDetailForms, userType,formSubmitted }) {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [allCountriesBL, setallCountriesBL] = useState([]);
  const [allStatesBL, setallStatesBL] = useState([]);
  const [allCitiesBL, setallCitiesBL] = useState([]);
  const [allCountriesSP, setallCountriesSP] = useState([]);
  const [vendorNameEmail, setVendorNameEmail] = useState(null);
  const [allStatesSP, setallStatesSP] = useState([]);
  const [allCitiesSP, setallCitiesSP] = useState([]);
  const [searchParm] = useSearchParams();
  const [filledData, setFilledData] = useState(null);
  const [dataFilled, setDataFilled] = useState(false);
  const [isEditMode, setIsEditMode] = useState(true);
  const [shippingAddAsBillingAddress, setShippingAddAsBillingAddress] =
    useState(false);
  const [AddressForm, setAddressForm] = useState({
    AddressID: 0,
    VendorGUID: "",
    BLAttention: "",
    BLCountry: "",
    BLState: "",
    BLCity: "",
    BLAddress1: "",
    BLAddress2: "",
    BLPincode: "",
    BLPhone: "",
    BLFaxNumber: "",
    SPAttention: "",
    SPCountry: "",
    SPState: "",
    SPCity: "",
    SPAddress1: "",
    SPAddress2: "",
    SPPincode: "",
    SPPhone: "",
    SPFaxNumber: "",
    CreatedBy: userType,
    ModifiedBy: "null",
  });

  useEffect(() => {
    if (searchParm.get("vendorID") != null) {
      checkDataFilled(searchParm.get("vendorID"));
      setAddressForm({
        ...AddressForm,
        VendorGUID: searchParm.get("vendorID"),
      });
      getCountry(1);
      getCountry(2);
      if (filledData !== null) {
        getState(filledData[0].BLCountry, 1);
        getCity(filledData[0].BLState, 1);
        getState(filledData[0].SPCountry, 2);
        getCity(filledData[0].SPState, 2);
      }
    }
  }, []);

  useEffect(() => {
    if (searchParm.get("vendorID") != null) {
      checkDataFilled(searchParm.get("vendorID"));
      getCountry(1);
      getCountry(2);
      setAddressForm({
        ...AddressForm,
        VendorGUID: searchParm.get("vendorID"),
      });
    }
  }, []);

  useEffect(() => {
    if (filledData !== null) {
      getState(filledData[0].BLCountry, 1);
      getCity(filledData[0].BLState, 1);
      getState(filledData[0].SPCountry, 2);
      getCity(filledData[0].SPState, 2);
    }
  }, [filledData]);

  useEffect(() => {
    if (
      filledData !== null &&
      filledData[0].BLState !== "" &&
      filledData[0].SPState !== ""
    ) {
      getCity(filledData[0].BLState, 1);
      getCity(filledData[0].SPState, 2);
    }
  }, [filledData]);

  function checkDataFilled(id) {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}admin/GETVendorAddressGUID?VendorID=${id}`, {})
      .then((response) => {
        if (response.data.data[0].VendorGUID != null) {
          setAddressForm(response.data.data[0]);

          setIsEditMode(false);
          setFilledData(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getCountry(type) {
    axios
      .get(`${baseAPI}admin/GETCountry?countryID=0`, {})
      .then((response) => {
        if (type === 1) {
          setallCountriesBL(response.data.data);
        } else {
          setallCountriesSP(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getState(country_id, type) {
    if (country_id != null && country_id != "0") {
      axios
        .get(`${baseAPI}Admin/GETState?stateID=0&countryID=` + country_id, {})
        .then((response) => {
          if (type === 1) {
            setallStatesBL(response.data.data);
          } else {
            setallStatesSP(response.data.data);
          }
        });
    }
  }

  function getCity(state_id, type) {
    if (state_id != null && state_id != "0") {
      axios
        .get(`${baseAPI}Admin/GETCity?cityID=0&stateID=` + state_id, {})
        .then((response) => {
          if (type === 1) {
            setallCitiesBL(response.data.data);
          } else {
            setallCitiesSP(response.data.data);
          }
        });
    }
  }

  function handleChange(e) {
    if (isEditMode) {
      const { name, value } = e.target;
      if (name === "BLCountry") {
        getState(value, 1);
      } else if (name === "BLState") {
        getCity(value, 1);
      } else if (name === "SPCountry") {
        getState(value, 2);
      } else if (name === "SPState") {
        getCity(value, 2);
      }
      setAddressForm({
        ...AddressForm,
        [name]: value,
      });
      if (shippingAddAsBillingAddress) {
        setAddressForm((prevAddressForm) => ({
          ...prevAddressForm,
          SPAttention: prevAddressForm.BLAttention,
          SPCountry: prevAddressForm.BLCountry,
          SPState: prevAddressForm.BLState,
          SPCity: prevAddressForm.BLCity,
          SPAddress1: prevAddressForm.BLAddress1,
          SPAddress2: prevAddressForm.BLAddress2,
          SPPincode: prevAddressForm.BLPincode,
          SPPhone: prevAddressForm.BLPhone,
          SPFaxNumber: prevAddressForm.BLFaxNumber,
        }));
      }
    }
  }

  function ResetForm() {
    setAddressForm({
      BLAttention: "",
      BLCountry: "",
      BLState: "",
      BLCity: "",
      BLAddress1: "",
      BLAddress2: "",
      BLPincode: "",
      BLPhone: "",
      BLFaxNumber: "",
      SPAttention: "",
      SPCountry: "",
      SPState: "",
      SPCity: "",
      SPAddress1: "",
      SPAddress2: "",
      SPPincode: "",
      SPPhone: "",
      SPFaxNumber: "",
      VendorGUID: searchParm.get("vendorID"),
    });
  }

  function AllowEditingData() {
    setIsEditMode(true);
  }

  function handleShippingAddress() {
    if (isEditMode) {
      setShippingAddAsBillingAddress(!shippingAddAsBillingAddress);
      if (!shippingAddAsBillingAddress) {
        setAddressForm({
          ...AddressForm,
          SPAttention: AddressForm.BLAttention,
          SPCountry: AddressForm.BLCountry,
          SPState: AddressForm.BLState,
          SPCity: AddressForm.BLCity,
          SPAddress1: AddressForm.BLAddress1,
          SPAddress2: AddressForm.BLAddress2,
          SPPincode: AddressForm.BLPincode,
          SPPhone: AddressForm.BLPhone,
          SPFaxNumber: AddressForm.BLFaxNumber,
        });
      } else {
        setAddressForm({
          ...AddressForm,
          SPAttention: "",
          SPCountry: "",
          SPState: "",
          SPCity: "",
          SPAddress1: "",
          SPAddress2: "",
          SPPincode: "",
          SPPhone: "",
          SPFaxNumber: "",
        });
      }
    }
  }

  function showClickedForm() {
    const newObj = {
      AddressForm: false,
      OtherDetailsForm: false,
      BankDetailsForm: false,
      ContactDetailsForm: false,
      TermsForm: false,
    };

    newObj.OtherDetailsForm = true;
    setShowDetailForms(newObj);
  }

  const validatePhoneNumber = (phoneNumber) => {
    const personalPhoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
    const workPhoneRegex =
      /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})(?: *x(\d+))?$/;

    return (
      personalPhoneRegex.test(phoneNumber) || workPhoneRegex.test(phoneNumber)
    );
  };

  const validateFaxNumber = (phoneNumber) => {
    const faxNumberRegex = /^[\d ()+-]+(?: *x\d+)?$/;
    return faxNumberRegex.test(phoneNumber);
  };

  const handleSubmit = async (e) => {
    let updatedData = {};
    if (AddressForm && AddressForm.AddressID !== 0) {
      updatedData = {
        ...AddressForm,
        CreatedBy: userType,
      };
    } else {
      updatedData = {
        ...AddressForm,
      };
    }

    for (const key in AddressForm) {
      if (key === "BLPincode" || key === "SPPincode" ||  key === "SPFaxNumber"||  key === "BLFaxNumber") {
        continue;
      } else {
        if (AddressForm[key] === "") {
          alert("All fields are mandatory. Please fill out all fields.");
          return;
        }
      }
    }
    if (!validatePhoneNumber(AddressForm.BLPhone)) {
      alert("Please enter a valid phone number.");
      return;
    }
    if (!validatePhoneNumber(AddressForm.SPPhone)) {
      alert("Please enter a valid phone number.");
      return;
    }
    if(AddressForm.BLFaxNumber!==""){
    if (!validateFaxNumber(AddressForm.BLFaxNumber)) {
      alert("Please enter a valid fax number.");
      return;
    }
  }
  if(AddressForm.SPFaxNumber!==""){
    if (!validateFaxNumber(AddressForm.SPFaxNumber)) {
      alert("Please enter a valid fax number.");
      return;
    }
  }
    showClickedForm();
    e.preventDefault();

    if (!isEditMode) {
      setAddressForm({
        ...AddressForm,
        AddressID: 0,
      });
    }

    try {
      const response = await axios.post(
        `${baseAPI}Admin/AddVendorAddressDetail`,
        updatedData
      );
      checkDataFilled(searchParm.get("vendorID"));
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  function showClickedForm() {
    const newObj = {
      AddressForm: false,
      OtherDetailsForm: false,
      BankDetailsForm: false,
      ContactDetailsForm: false,
      TermsForm: false,
    };

    newObj.OtherDetailsForm = true;
    setShowDetailForms(newObj);
  }

  function cancelEdit() {
    checkDataFilled(searchParm.get("vendorID"));
    setIsEditMode(false);
  }

  // console.log(AddressForm);

  return (
    <div className="container-fluid adress_form_main_parent_div">
      <div>
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <div className="vendor_address_main_div">
              <h4>Billing Address</h4>
              <table>
                <tbody>
                  <tr>
                    <td>Attention</td>
                    <input
                      type="text"
                      name="BLAttention"
                      placeholder="Please Enter*"
                      required
                      onChange={handleChange}
                      value={AddressForm.BLAttention}
                    />
                  </tr>
                  <tr>
                    <td>Country/Region</td>
                    <select
                      className="form-control"
                      name="BLCountry"
                      onChange={handleChange}
                      required
                      value={AddressForm.BLCountry}
                    >
                      <option value="0">Select an option</option>
                      {allCountriesBL.map((item) => (
                        <option value={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </tr>
                  <tr>
                    <td>State</td>
                    <select
                      className="form-control"
                      name="BLState"
                      onChange={handleChange}
                      required
                      value={AddressForm.BLState}
                    >
                      <option>Select an option</option>
                      {allStatesBL.map((item) => (
                        <option value={item.state_id}>{item.stateName}</option>
                      ))}
                    </select>
                  </tr>
                  <tr>
                    <td>City</td>
                    <select
                      className="form-control"
                      name="BLCity"
                      required
                      onChange={handleChange}
                      value={AddressForm.BLCity}
                    >
                      <option value="0">Select an option</option>
                      {allCitiesBL.map((item) => (
                        <option value={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <input
                      style={{ padding: "33px" }}
                      type="text"
                      name="BLAddress1"
                      placeholder="Street 1"
                      onChange={handleChange}
                      value={AddressForm.BLAddress1}
                      required
                    />
                    <br></br>
                    <input
                      style={{ padding: "33px" }}
                      type="text"
                      name="BLAddress2"
                      placeholder="Street 2"
                      value={AddressForm.BLAddress2}
                      onChange={handleChange}
                      required
                    />
                  </tr>
                  <tr>
                    <td>Pin Code</td>
                    <input
                      type="number"
                      name="BLPincode"
                      placeholder="Please Enter*"
                      onChange={handleChange}
                      value={AddressForm.BLPincode}
                      required
                    />
                  </tr>
                  <tr>
                    <td>Phone</td>
                    <input
                      type="text"
                      name="BLPhone"
                      placeholder="Please Enter*"
                      onChange={handleChange}
                      value={AddressForm.BLPhone}
                      required
                    />
                  </tr>
                  <tr>
                    <td>Fax Number</td>
                    <input
                      type="text"
                      name="BLFaxNumber"
                      placeholder="Please Enter*"
                      onChange={handleChange}
                      value={AddressForm.BLFaxNumber}
                      required
                    />
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <div
              className={`${
                userType === "admin" ? "shipping_table_admin " : ""
              }`}
            >
              <div
                className={`container-fluid vendor_address_main_div ${
                  userType === "admin"
                    ? "admin_type_shipping_adress_main_div"
                    : ""
                }`}
              >
                <div style={{ display: "flex" }}>
                  <h4> Shipping Address</h4>
                  <h6>Same as Billing Address</h6>
                  {filledData === null ? (
                    <input
                      name="checkbox"
                      id="myCheckbox"
                      type="checkbox"
                      onChange={handleShippingAddress}
                    />
                  ) : filledData !== null && isEditMode ? (
                    <input
                      name="checkbox"
                      id="myCheckbox"
                      type="checkbox"
                      onChange={handleShippingAddress}
                    />
                  ) : (
                    ""
                  )}
                </div>

                <table>
                  <tbody>
                    <tr>
                      <td>Attention</td>
                      <input
                        type="text"
                        name="SPAttention"
                        required
                        value={
                          shippingAddAsBillingAddress
                            ? AddressForm.BLAttention
                            : AddressForm.SPAttention
                        }
                        onChange={handleChange}
                        placeholder="Enter Attention"
                      />
                    </tr>
                    <tr>
                      <td>Country/Region</td>
                      <select
                        className="form-control"
                        name="SPCountry"
                        onChange={handleChange}
                        required
                        value={
                          shippingAddAsBillingAddress
                            ? AddressForm.BLCountry
                            : AddressForm.SPCountry
                        }
                      >
                        <option value="0">Select an option</option>
                        {allCountriesSP.map((item) => (
                          <option value={item.id}>{item.name}</option>
                        ))}
                      </select>
                    </tr>
                    <tr>
                      <td>State</td>
                      <select
                        className="form-control"
                        name="SPState"
                        onChange={handleChange}
                        required
                        value={
                          shippingAddAsBillingAddress
                            ? AddressForm.BLState
                            : AddressForm.SPState
                        }
                      >
                        <option value="0">Select an option</option>
                        {shippingAddAsBillingAddress
                          ? allStatesBL.map((item) => (
                              <option value={item.state_id}>
                                {item.stateName}
                              </option>
                            ))
                          : allStatesSP.map((item) => (
                              <option value={item.state_id}>
                                {item.stateName}
                              </option>
                            ))}
                      </select>
                    </tr>
                    <tr>
                      <td>City</td>
                      <select
                        className="form-control"
                        name="SPCity"
                        required
                        onChange={handleChange}
                        value={
                          shippingAddAsBillingAddress
                            ? AddressForm.BLCity
                            : AddressForm.SPCity
                        }
                      >
                        <option value="0">Select an option</option>
                        {shippingAddAsBillingAddress
                          ? allCitiesBL.map((item) => (
                              <option value={item.id}>{item.name}</option>
                            ))
                          : allCitiesSP.map((item) => (
                              <option value={item.id}>{item.name}</option>
                            ))}
                      </select>
                    </tr>
                    <tr>
                      <td>Address</td>
                      <input
                        style={{ padding: "33px" }}
                        type="text"
                        name="SPAddress1"
                        placeholder="Street 1"
                        required
                        onChange={handleChange}
                        value={
                          shippingAddAsBillingAddress
                            ? AddressForm.BLAddress1
                            : AddressForm.SPAddress1
                        }
                      />
                      <br></br>

                      <input
                        style={{ padding: "33px" }}
                        type="text"
                        name="SPAddress2"
                        placeholder="Street 2"
                        onChange={handleChange}
                        value={
                          shippingAddAsBillingAddress
                            ? AddressForm.BLAddress2
                            : AddressForm.SPAddress2
                        }
                        required
                      />
                    </tr>
                    <tr>
                      <td>Pin Code</td>
                      <input
                        type="number"
                        name="SPPincode"
                        placeholder="Please Enter*"
                        onChange={handleChange}
                        value={
                          shippingAddAsBillingAddress
                            ? AddressForm.BLPincode
                            : AddressForm.SPPincode
                        }
                        required
                      />
                    </tr>
                    <tr>
                      <td>Phone</td>
                      <input
                        type="text"
                        name="SPPhone"
                        placeholder="Please Enter*"
                        onChange={handleChange}
                        value={
                          shippingAddAsBillingAddress
                            ? AddressForm.BLPhone
                            : AddressForm.SPPhone
                        }
                        required
                      />
                    </tr>
                    <tr>
                      <td>Fax Number</td>
                      <input
                        type="text"
                        name="SPFaxNumber"
                        placeholder="Please Enter*"
                        onChange={handleChange}
                        value={
                          shippingAddAsBillingAddress
                            ? AddressForm.BLFaxNumber
                            : AddressForm.SPFaxNumber
                        }
                        required
                      />
                    </tr>
                  </tbody>
                </table>
                <br />
                <div
                  className={`reset-addSupplier-button ${
                    userType === "admin" ? "admin_address_buttons_div" : ""
                  }`}
                >
                  {filledData === null ? (
                     formSubmitted?
                     null
                     :
                    <button
                      disabled={filledData !== null ? true : false}
                      type="submit"
                      onClick={handleSubmit}
                      style={{
                        backgroundColor: "#5B489D",
                        color: "white",
                      }}
                    >
                      Next
                    </button>
                  ) : isEditMode ? (
                    formSubmitted?
                    null
                    :
                    <button
                      type="submit"
                      onClick={handleSubmit}
                      style={{
                        backgroundColor: "#5B489D",
                        color: "white",
                      }}
                    >
                      Update
                    </button>
                  ) : (
            formSubmitted?
            null
            :
                    <button
                      type="submit"
                      onClick={AllowEditingData}
                      style={{
                        backgroundColor: "#5B489D",
                        color: "white",
                      }}
                    >
                      Edit
                    </button>
                  )}

                  {filledData !== null ? (
                     formSubmitted?
                     null
                     :
                    <button
                      onClick={cancelEdit}
                      style={{
                        backgroundColor: "white",
                        color: "red",
                        border: "none",
                      }}
                    >
                      Cancel
                    </button>
                  ) : (
                    formSubmitted?
                    null
                    :
                    <button
                      onClick={ResetForm}
                      style={{
                        backgroundColor: "white",
                        color: "red",
                        border: "none",
                      }}
                    >
                      Reset
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddVendorAddress;
